import AccountReceivableListModal from '@/components/_common/AccountReceivableListModal';
import { AccountReceivableSituation } from '@/core/domain/financial/AccountReceivable/AccountReceivable.types';
import { useDisclosure } from '@/hooks';
import { DateTimeFormat } from '@/utils/moment';
import moment from 'moment';
import React from 'react';
import {
  StatisticDashboardModule,
  StatisticDashboardTypeColor,
} from '@/components/_common/StatisticDashboard';
import DashboardStatisticCard from '../../DashboardStatisticCard';
import formatterPrice from '@/utils/number/formatterPrice';

interface Props {
  value: number;
}

const ReceivablePayDayValue: React.FC<Props> = ({ value }) => {
  const [viewAccountReceivablesOpen, viewAccountReceivablesActions] =
    useDisclosure();

  return (
    <>
      <DashboardStatisticCard
        tooltipTitle="Valor de parcelas recebidas hoje."
        statisticTitle="Parcelas recebidas | Dia"
        color={StatisticDashboardTypeColor.income}
        value={formatterPrice(value || 0)}
        module={StatisticDashboardModule.accountReceivable}
        onClick={viewAccountReceivablesActions.open}
      />

      <AccountReceivableListModal
        open={viewAccountReceivablesOpen}
        onCancel={viewAccountReceivablesActions.close}
        queryFilter={{
          situation: AccountReceivableSituation.settled,
          payDate: moment().format(DateTimeFormat),
        }}
      />
    </>
  );
};

export default ReceivablePayDayValue;
